import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EventTypeEnum } from '@application/enums/event-type-enum';
import { setEventType } from '@application/features/f1Integration/f1Slice';
import { Icon } from '@iconify/react';
import { isVideo } from '@application/helpers/video-detection-helper';
import { Box, Card, CardContent, CardMedia, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useScheduledEventItemStyles } from './useScheduledEventItemStyles';
import { hasPermission } from '@application/helpers/permission-helper';
import { useTranslation } from 'react-i18next';
import { useResponsive } from '@ui/style/useResponsive';
import AvatarGroup from '@ui/components/common/AvatarGroup';
const ScheduledEventItem = ({ event, selectedId, setSelectedId, setSelectedEventName }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { isMobileIpadNavigation } = useResponsive();
    const styles = useScheduledEventItemStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loggedInUserPermissions = useSelector((state) => state.auth.currentUser?.permissions || []);
    const canReadEvents = hasPermission(loggedInUserPermissions, 'Permissions.VdkEvents.Read');
    return (_jsx(Card, { sx: {
            ...styles.card,
            cursor: 'pointer',
            border: selectedId === event.id
                ? `1px solid ${theme.palette.primary.darker}`
                : `1px solid #919EAB52`,
            '&:hover': {
                border: selectedId === event.id
                    ? `1px solid ${theme.palette.primary.darker}`
                    : `1px solid ${theme.palette.primary.darker}`
            }
        }, onClick: () => {
            setSelectedId(event.id);
            setSelectedEventName?.(event.title);
        }, children: _jsxs(CardContent, { sx: {
                ...styles.content,
                flexDirection: 'row',
                flex: 1,
                minWidth: 0,
                alignItems: 'center',
                gap: 2
            }, children: [!isMobileIpadNavigation && (_jsx(Box, { sx: { ...styles.imageContainer, flexShrink: 0 }, children: isVideo(undefined, event.image) ? (_jsx(CardMedia, { component: 'video', src: event.image, autoPlay: true, muted: true, loop: true, playsInline: true, sx: {
                            ...styles.image,
                            objectFit: 'cover'
                        } })) : (_jsx(CardMedia, { component: 'img', image: event.eventType == EventTypeEnum.Family ||
                            event.eventType == EventTypeEnum.Director
                            ? '/assets/images/defaultbackground/default_background_image.jpg'
                            : event.image, alt: event.title, sx: styles.image })) })), _jsxs(Box, { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5, children: [_jsx(Typography, { variant: 'body1', sx: {
                                ...styles.title,
                                color: theme.palette.text.primary
                            }, children: event.title }), _jsx(Typography, { variant: 'body2', sx: {
                                ...styles.dateRange,
                                color: theme.palette.text.primary
                            }, children: event.dateRange }), _jsx(Typography, { variant: 'caption', sx: {
                                ...styles.group,
                                color: theme.palette.text.secondary
                            }, children: event.companies.length === 0 ? ('—') : event.companies.length === 1 ? (event.companies[0].label) : (_jsx(Tooltip, { title: event.companies.map((c) => c.label).join(', '), slotProps: {
                                    tooltip: {
                                        sx: {
                                            maxHeight: '200px',
                                            overflowY: 'auto',
                                            maxWidth: '300px'
                                        }
                                    }
                                }, children: _jsxs("span", { children: [event.companies[0].label, " +", event.companies.length - 1, " more"] }) })) })] }), _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0, children: [event.organizer.length > 0 && (_jsx(Tooltip, { title: t(`events.eventDetails.generalInfoTab.happinessOfficersAssigned`, {
                                count: event.organizer.length
                            }), placement: 'top', children: _jsx(Box, { children: _jsx(AvatarGroup, { users: event.organizer.map((organizer) => ({
                                        id: organizer.id || organizer.name,
                                        avatar: organizer.avatar,
                                        firstName: organizer.firstName,
                                        lastName: organizer.lastName,
                                        name: organizer.name
                                    })), showTooltip: true }) }) })), _jsx(Tooltip, { arrow: true, title: t('events.eventDetails.details'), placement: 'top', children: _jsx(IconButton, { disabled: !canReadEvents, onClick: (e) => {
                                    e.stopPropagation();
                                    let url = `/event-details/${event.id}`;
                                    if (event.eventType &&
                                        (event.eventType === EventTypeEnum.Family ||
                                            event.eventType === EventTypeEnum.Director)) {
                                        url += `/${event.eventType}`;
                                        dispatch(setEventType(event.eventType));
                                    }
                                    navigate(url);
                                }, sx: {
                                    width: 36,
                                    height: 36,
                                    borderRadius: '12px',
                                    backgroundColor: theme.palette.text.primary,
                                    color: theme.palette.common.white,
                                    '&:hover': {
                                        backgroundColor: theme.palette.text.primary
                                    },
                                    '&:disabled': {
                                        backgroundColor: theme.palette.action.disabledBackground,
                                        color: theme.palette.action.disabled
                                    }
                                }, children: _jsx(Icon, { icon: 'eva:arrow-forward-fill' }) }) })] })] }) }));
};
export default ScheduledEventItem;
